import './bootstrap';
import { createApp } from 'vue';
import Illustration from "./common-components/Illustration";
window.publicApp = true;

const app = createApp(Illustration)

app.mount('#app');
